'use strict';let

ModalSubmissionResult=class ModalSubmissionResult{
constructor(type){
this._type=type;
}

get type(){
return this._type;
}};let


KeepOpen=class KeepOpen extends ModalSubmissionResult{
constructor(){
super('KeepOpen');
}};let


Abandon=class Abandon extends ModalSubmissionResult{
constructor(){
super('Abandon');
}};let


Close=class Close extends ModalSubmissionResult{
constructor(result){
super('Close');
this._result=result;
}

get result(){
return this._result;
}};let


Dismiss=class Dismiss extends ModalSubmissionResult{
constructor(reason){
super('Dismiss');
this._reason=reason;
}

get reason(){
return this._reason;
}};


module.exports=ModalSubmissionResult;
module.exports.KeepOpen=new KeepOpen;
module.exports.Abandon=new Abandon;
module.exports.Close=result=>new Close(result);
module.exports.Dismiss=reason=>new Dismiss(reason);
module.exports.FromError=error=>error.constructor.name==='AccessDeniedError'?ModalSubmissionResult.KeepOpen:ModalSubmissionResult.Abandon;
//# sourceMappingURL=modalSubmissionResult.js.map
